<template lang="pug">
v-dialog(
  scrollable lazy
  v-model='dialog'
  :max-width='dialogMaxWidth'
  :fullscreen='isFullscreen'
  :transition='transition'
)
  v-card(@keyup.esc='close')
    v-img.white--text(height='auto' :aspect-ratio='16/9'  :src='info.photo || ``' gradient=`to top, rgba(0, 0, 0, .5) , rgba(0, 0, 0, .5) `)
      .pa-4
        .headline {{ info.title }}
        v-container.pa-0(grid-list-lg)
          v-layout(row wrap justify-center)
            v-flex(xs12): Logo(:size='320').my-3
            v-flex(xs12 v-if='result && result.length === 0'): .title.grey--text.show-up 未抽出得獎者
            v-flex(xs12 sm6 md4 v-for='(i, index) in result' :key='index')
              LotteryWinnerCard.show-up(:data='i' :style='`animation-delay: ${index * .3 + .5}s`' :hide-detail='true')

      v-card-actions
        v-spacer
        v-btn(flat dark @click='dialog = false') 確認
</template>

<script>
import { formStatus } from '@/mixins/formStatus'
import Loader from '@/components/Loader.vue'
import Logo from '@/components/Logo.vue'

import LotteryWinnerCard from '@/components/lottery/LotteryWinnerCard.vue'

export default {
  name: 'LotteryResult',
  data () {
    return {
      result: null,
      info: {},
    }
  },
  methods: {
    show (result, info) {
      this.dialog = true
      this.result = result
      this.info = info
    },
  },
  computed: {
    dialogMaxWidth () {
      return 1000
    },
    isFullscreen () {
      return this.isMobile
    },
    transition () {
      return this.isFullscreen ? 'dialog-bottom-transition' : 'dialog-transition'
    },
  },
  components: {
    Loader,
    LotteryWinnerCard,
    Logo,
  },
  mixins: [formStatus],
}
</script>

<style scoped lang='sass'>
.v-card__actions
  position: absolute
  bottom: 0
  width: 100%

.headline
  text-align: center
  padding: 1rem 0

.title
  text-align: center

@keyframes down-to-up
  from
    opacity: 0
    transform: scale(.5)
  to
    transform: 0

.show-up
  animation: down-to-up .5s cubic-bezier(0.4, 0.0, 0.2, 1)
  animation-fill-mode: backwards

</style>
